import { type ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { PhotoCardPreview } from '@/components/upload/photo-card-preview';

export type PhotoState = {
  file: globalThis.File | null;
  preview: string | null;
};

export function readFile(
  e: React.ChangeEvent<HTMLInputElement>
): PhotoState | null {
  const f = e.target.files?.[0];
  if (!f) return null;
  return { file: f, preview: URL.createObjectURL(f) };
}

export function Preview(p: { src: string; onPick: () => void }): ReactNode {
  return (
    <div className="flex flex-col items-center gap-sm">
      <PhotoCardPreview src={p.src} className="w-44" />
      <Button variant="ghost" size="sm" onClick={p.onPick}>
        Cambiar foto
      </Button>
    </div>
  );
}

export function Actions(p: {
  onConfirm: () => void;
  onCancel: () => void;
  disabled: boolean;
  pending: boolean;
}): ReactNode {
  return (
    <div className="flex justify-end gap-sm">
      <Button variant="ghost" size="sm" onClick={p.onCancel}>
        Cancelar
      </Button>
      <Button
        variant="primary"
        size="sm"
        onClick={p.onConfirm}
        disabled={p.disabled || p.pending}
      >
        {p.pending ? 'Subiendo...' : 'Confirmar'}
      </Button>
    </div>
  );
}

export function PickArea(p: {
  preview: string | null;
  onPick: () => void;
}): ReactNode {
  if (p.preview) return <Preview src={p.preview} onPick={p.onPick} />;
  return (
    <div className="flex justify-center">
      <Button variant="secondary" size="sm" onClick={p.onPick}>
        Elegir nueva foto
      </Button>
    </div>
  );
}
